import 'rxjs/Rx';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AccomSupportService {

    constructor(private http: HttpClient) { }
    getAccomSupport(req: any) {
        return this.http.post(`/api/AccomSupport/getAccomSupportDetails`, req,
            {
                responseType: 'json'
            });
    }
}



// WEBPACK FOOTER //
// ./client/app/internal/common/services/accomsupport.service.ts